import * as actionTypes from '../actions/actionTypes';
import uuid from 'uuid';
import { SESSION, SESSION_UUID, SESSION_USERNAME, SESSION_SUPERUSER } from "../../shared/Constants";

const initialState = {
    //firstName, lastName, userLoginId, universalId, superUser, loggedIn
    user: null,
    loading: false,
    disableUser: false,
    token: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CHECK_SUPER_USER_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    superUser: action.superUser
                }
            };
        case actionTypes.SET_USER_TYPE:
            return{
                ...state,
                user: {
                    ...state.user,
                    userType: action.userType
                }
            }
        case actionTypes.CHECK_DISABLE_USER_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    disableUser: action.disableUser
                }
            };
        case actionTypes.CHECK_DISABLE_USER_FAIL:
            return {
                ...state,
                user: {
                    ...state.user,
                    disableUser: action.disableUser
                }
            };
        case actionTypes.SET_USER_SESSION:
            const txnId = uuid.v4(), now = new Date();
            const sessionId = txnId + "-" + now.getTime();
            if(!localStorage.getItem(SESSION)) {
                localStorage.setItem(SESSION, sessionId);
            }
            if(!localStorage.getItem(SESSION_UUID)) {
                localStorage.setItem(SESSION_UUID, uuid.v4());
            }
            if(!localStorage.getItem(SESSION_USERNAME)) {
                localStorage.setItem(SESSION_USERNAME, action.username);
            }
            let newUser3 = {...state.user};
            newUser3.sessionId = sessionId;
            return {
                ...state,
                user: newUser3
            }
        case actionTypes.LOGOUT_USER:
            localStorage.removeItem(SESSION);
            localStorage.removeItem(SESSION_UUID);
            localStorage.removeItem(SESSION_USERNAME);
            localStorage.removeItem(SESSION_SUPERUSER);
            return {
                ...state,
                loading: false,
                user: null,
            }
        case actionTypes.FETCH_USER_START:
            return {
                ...state,
                loading: true,
                user: {
                    ...state.user,
                    loggedIn: false
                }
            }
        case actionTypes.FETCH_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: {
                    ...state.user,
                    userLoginId: action.user.username,
                    displayName: action.user.name,
                    loggedIn: true
                }
            }
        case actionTypes.FETCH_USER_FAILED:
            return {
                ...state,
                user: {
                    ...state.user,
                    loggedIn: false
                },
                loading: false
            }
        case actionTypes.SET_USER_EMPLOYEEID:
            return {
                ...state,
                user: {
                    ...state.user,
                    employeeId: action.employeeId,
                },
                loading: false
            }
            
        case actionTypes.CHECK_AGENT_ACCESS_SUCCESS:
            return{
                ...state,
                user: {
                    ...state.user,
                    userType: action.userType,
                    agentEmailId: action.agentEmailId,
                    featureTestRole: action.featureTestRole,
                    features: action.features ? {...action.features} : {},
                }
            }
        case actionTypes.FETCH_ACCESS_TOKEN:
            return{
                ...state,
                token: action.token
            }
        default:
            return state;
    }

}

export default reducer;